import { useQuery } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import { getPrivateInstance } from "../_privateInstance";
import { DEFAULT_TOP_RANKING_LIMIT } from "../../utils/kpiRankingMetric";
import {
  parseSportsbookTopSportsResponse,
  type SportsbookRankingRow,
  type SportsbookTopSportsData,
} from "./normalizeSportsbookRankingRows";

export type SportsbookTopSportsFilters = {
  start_date: string;
  end_date: string;
  /** Number of ranked rows to return (BE: 1–50). Defaults to 10. */
  limit?: number;
};

export type SportsbookTopSportRow = SportsbookRankingRow;

export const fetchSportsbookTopSports = async (
  filters: SportsbookTopSportsFilters,
): Promise<SportsbookTopSportsData> => {
  const instance = getPrivateInstance();
  const { start_date, end_date, limit = DEFAULT_TOP_RANKING_LIMIT } = filters;
  const response = await instance.get(API_ROUTES.SPORTSBOOK_TOP_SPORTS, {
    params: { start_date, end_date, limit },
  });
  return parseSportsbookTopSportsResponse(response?.data);
};

export const useGetSportsbookTopSports = (filters: SportsbookTopSportsFilters) => {
  const {
    start_date,
    end_date,
    limit = DEFAULT_TOP_RANKING_LIMIT,
  } = filters;

  return useQuery<SportsbookTopSportsData, Error>({
    queryKey: ["SPORTSBOOK_TOP_SPORTS", start_date, end_date, limit],
    queryFn: () => fetchSportsbookTopSports(filters),
    enabled: Boolean(start_date && end_date),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
